import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";

const url = "api/admin/codeMng/";

export async function readAllcodeTypeApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_all_code_type", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readCodeEntriesByCodeTypeApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_code_entries_by_code_type", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function createCodeEntriesApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_code_entries", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateCodeEntriesApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_code_entries", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function deleteCodeEntriesApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_code_entries", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function manualSyncAllApi(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "manual_sync/all");
    } catch (err: any) {
        return err?.response;
    }
}